import { ErrorElement } from '@frontend/shared/web';
import { createBrowserRouter, Navigate } from 'react-router-dom';

import { constants, FEATURES } from '../../constants';
import { AcceptInvitationRoute } from '../../routes/accept-invitation-route/AcceptInvitationRoute';
import { AdminRoute } from '../../routes/admin-route';
import { AnonymousLayout } from '../../routes/anonymous-layout';
import { AuthenticatedLayout } from '../../routes/authenticated-layout';
import { ExportsRoute } from '../../routes/exports-route';
import { HomeRoute } from '../../routes/HomeRoute';
import { IncidentsRoute } from '../../routes/incidents-route';
import { InvoicesRoute } from '../../routes/invoices-route';
import { LoginRoute } from '../../routes/login-route/LoginRoute';
import { LostFoundRoute } from '../../routes/lost-found-route';
import { NotFoundRoute } from '../../routes/not-found-route/NotFoundRoute';
import { RequireAdminArea } from '../../routes/RequireAdminArea';
import { RequirePermission } from '../../routes/RequirePermission';

export const routes = createBrowserRouter(
  [
    {
      element: <AnonymousLayout />,
      errorElement: <ErrorElement />,
      children: [
        { path: 'login', element: <LoginRoute />, errorElement: <ErrorElement /> },
        { path: 'not-found', element: <NotFoundRoute />, errorElement: <ErrorElement /> },
      ],
    },
    // Hors des deux layouts : un utilisateur connecté ne doit pas être renvoyé sur `/`.
    { path: 'invitation/accept', element: <AcceptInvitationRoute />, errorElement: <ErrorElement /> },
    {
      element: <AuthenticatedLayout />,
      errorElement: <ErrorElement />,
      children: [
        { path: '/', element: <HomeRoute />, errorElement: <ErrorElement /> },
        ...(FEATURES.incidents
          ? [
              {
                path: 'incidents',
                element: (
                  <RequirePermission permission="extranet-incidents">
                    <IncidentsRoute />
                  </RequirePermission>
                ),
                errorElement: <ErrorElement />,
              },
            ]
          : []),
        {
          path: 'exports',
          element: (
            <RequirePermission permission="extranet-exports">
              <ExportsRoute />
            </RequirePermission>
          ),
          errorElement: <ErrorElement />,
        },
        // L'écran Performance est devenu Export le 11 septembre 2026 : on garde la
        // redirection, des liens et des favoris pointent encore sur l'ancienne URL.
        { path: 'performance', element: <Navigate to="/exports" replace />, errorElement: <ErrorElement /> },
        {
          path: 'invoices',
          element: (
            <RequirePermission permission="extranet-billing">
              <InvoicesRoute />
            </RequirePermission>
          ),
          errorElement: <ErrorElement />,
        },
        ...(FEATURES.lostFound
          ? [
              {
                path: 'lost-found',
                element: (
                  <RequirePermission permission="extranet-trips">
                    <LostFoundRoute />
                  </RequirePermission>
                ),
                errorElement: <ErrorElement />,
              },
            ]
          : []),
        {
          path: 'admin',
          element: (
            <RequireAdminArea>
              <AdminRoute />
            </RequireAdminArea>
          ),
          errorElement: <ErrorElement />,
        },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/not-found" replace />,
    },
  ],
  {
    basename: constants.basename,
  },
);
